import IAction from "../../types/IAction";
import { readMessageBack } from "../../utils/readMessageBack";
import actionTypes from "../actionTypes";
import AnualidadMetaCarga from "../../types/AnualidadMetaCarga";
import AnualidadAcumuladoResumen from "../../types/AnualidadAcumuladoResumen";
import VendedorActualizacionResumen from "../../types/VendedorActualizacionResumen";
import AnualidadProceso from "../../types/AnualidadProceso";
import AnualidadProyecto from "../../types/AnualidadProyecto";
import Option from "../../types/Option";
import { Result } from "../../types/Result";
import ComisionAlcance from "../../types/ComisionAlcance";

export interface PostComisionAnualidadCargaMetas {
  cargaAnualidadMeta: AnualidadMetaCarga;
  postingCargaAnualidadMeta: boolean;
  postingCargaAnualidadMetaError: string;
}

export interface GetComisionAnualidadMetas {
  comisionAnualidadMetas: AnualidadMetaCarga;
  gettingComisionAnualidadMetas: boolean;
  gettingComisionAnualidadMetasError: string;
}

export interface GetComisionAlcanceAnualidad {
  comisionesAlcanceAnualidad: ComisionAlcance[];
  gettingComisionesAlcanceAnualidad: boolean;
  gettingComisionesAlcanceAnualidadError: string;
}

export interface GetSnapshot {
  snapshot: any;
  gettingSnapshot: boolean;
  gettingSnapshotError: string;
}

export interface PostSnapshotByPeriodo {
  postSnapshotResult: any;
  postingSnapshotByPeriodo: boolean;
  postingSnapshotByPeriodoError: string;
}

export interface PutSnapshotEvaluacion {
  putSnapshotEvaluacionResult: any;
  puttingSnapshotEvaluacion: boolean;
  puttingSnapshotEvaluacionError: string;
}

export interface DeleteSnapshotEvaluacion {
  deleteSnapshotEvaluacionResult: any;
  deletingSnapshotEvaluacion: boolean;
  deletingSnapshotEvaluacionError: string;
}

export interface GetResumen {
  resumenSnapshot: AnualidadAcumuladoResumen;
  gettingResumenSnapshot: boolean;
  gettingResumenSnapshotError: string;
}

export interface PutCambiarVendedor {
  cambiarVendedorResult: any;
  puttingCambiarVendedor: boolean;
  puttingCambiarVendedorError: string;
}

export interface PutCambiarPeriodo {
  cambiarPeriodoResult: any;
  puttingCambiarPeriodo: boolean;
  puttingCambiarPeriodoError: string;
}

export interface PostCambiarVendedorMasivo {
  cambiarVendedorMasivoResult: VendedorActualizacionResumen[];
  postingCambiarVendedorMasivo: boolean;
  postingCambiarVendedorMasivoError: string;
}

export interface GetEstadoProceso {
  estadoProceso: AnualidadProceso;
  gettingEstadoProceso: boolean;
  gettingEstadoProcesoError: string;
}

export interface PostCalcularAlcancesContactCenter {
  calcularAlcancesCCResult: Result;
  postingCalcularAlcancesCC: boolean;
  postingCalcularAlcancesCCError: string;
}

export interface PostPrecalculoContactCenter {
  precalculoCCResult: Result;
  postingPrecalculoCC: boolean;
  postingPrecalculoCCError: string;
}

export interface PostCalcularComisionesContactCenter {
  calcularComisionesCCResult: Result;
  postingCalcularComisionesCC: boolean;
  postingCalcularComisionesCCError: string;
}

export interface PostCalcularAlcancesClub {
  calcularAlcancesClubResult: Result;
  postingCalcularAlcancesClub: boolean;
  postingCalcularAlcancesClubError: string;
}

export interface PostPrecalculoClub {
  precalculoClubResult: Result;
  postingPrecalculoClub: boolean;
  postingPrecalculoClubError: string;
}

export interface PostCalcularComisionesClub {
  calcularComisionesClubResult: Result;
  postingCalcularComisionesClub: boolean;
  postingCalcularComisionesClubError: string;
}

export interface PostCalcularComisionesSemestral {
  calcularComisionesSemestralResult: Result;
  postingCalcularComisionesSemestral: boolean;
  postingCalcularComisionesSemestralError: string;
}

export interface GetCalculoSemestralAceptable {
  calculoSemestralAceptable: boolean;
  gettingCalculoSemestralAceptable: boolean;
  gettingCalculoSemestralAceptableError: string;
}

export interface DeleteRevertirAlcancesContactCenter {
  revertirAlcancesCCResult: Result;
  deletingRevertirAlcancesCC: boolean;
  deletingRevertirAlcancesCCError: string;
}

export interface DeleteRevertirPrecalculoContactCenter {
  revertirPrecalculoCCResult: Result;
  deletingRevertirPrecalculoCC: boolean;
  deletingRevertirPrecalculoCCError: string;
}

export interface DeleteRevertirComisionesContactCenter {
  revertirComisionesCCResult: Result;
  deletingRevertirComisionesCC: boolean;
  deletingRevertirComisionesCCError: string;
}

export interface DeleteRevertirAlcancesClub {
  revertirAlcancesClubResult: Result;
  deletingRevertirAlcancesClub: boolean;
  deletingRevertirAlcancesClubError: string;
}

export interface DeleteRevertirPrecalculoClub {
  revertirPrecalculoClubResult: Result;
  deletingRevertirPrecalculoClub: boolean;
  deletingRevertirPrecalculoClubError: string;
}

export interface DeleteRevertirComisionesClub {
  revertirComisionesClubResult: Result;
  deletingRevertirComisionesClub: boolean;
  deletingRevertirComisionesClubError: string;
}

export interface DeleteRevertirComisionesSemestral {
  revertirComisionesSemestralResult: Result;
  deletingRevertirComisionesSemestral: boolean;
  deletingRevertirComisionesSemestralError: string;
}

export interface GetLiderClubes {
  liderClubes: any[];
  gettingLiderClubes: boolean;
  gettingLiderClubesError: string;
}

export interface GetLiderReporte {
  liderReporte: any[]; // Lista de AnualidadSnapshot
  gettingLiderReporte: boolean;
  gettingLiderReporteError: string;
}

export interface GetAnualidadProyecto {
  anualidadProyecto: AnualidadProyecto;
  gettingAnualidadProyecto: boolean;
  gettingAnualidadProyectoError: string;
}

export interface GetAnualidadProyectosOptions {
  anualidadProyectosOptions: Option<string>[];
  gettingAnualidadProyectosOptions: boolean;
  gettingAnualidadProyectosOptionsError: string;
}

export interface State
  extends PostComisionAnualidadCargaMetas,
    GetComisionAnualidadMetas,
    GetComisionAlcanceAnualidad,
    GetSnapshot,
    PostSnapshotByPeriodo,
    PutSnapshotEvaluacion,
    DeleteSnapshotEvaluacion,
    GetResumen,
    PutCambiarVendedor,
    PutCambiarPeriodo,
    PostCambiarVendedorMasivo,
    GetEstadoProceso,
    PostCalcularAlcancesContactCenter,
    PostPrecalculoContactCenter,
    PostCalcularComisionesContactCenter,
    PostCalcularAlcancesClub,
    PostPrecalculoClub,
    PostCalcularComisionesClub,
    PostCalcularComisionesSemestral,
    GetCalculoSemestralAceptable,
    DeleteRevertirAlcancesContactCenter,
    DeleteRevertirPrecalculoContactCenter,
    DeleteRevertirComisionesContactCenter,
    DeleteRevertirAlcancesClub,
    DeleteRevertirPrecalculoClub,
    DeleteRevertirComisionesClub,
    DeleteRevertirComisionesSemestral,
    GetLiderClubes,
    GetLiderReporte,
    GetAnualidadProyecto,
    GetAnualidadProyectosOptions {}

const initialState: State = {
  cargaAnualidadMeta: null,
  postingCargaAnualidadMeta: false,
  postingCargaAnualidadMetaError: null,
  comisionAnualidadMetas: null,
  gettingComisionAnualidadMetas: false,
  gettingComisionAnualidadMetasError: null,
  comisionesAlcanceAnualidad: [],
  gettingComisionesAlcanceAnualidad: false,
  gettingComisionesAlcanceAnualidadError: null,
  snapshot: null,
  gettingSnapshot: false,
  gettingSnapshotError: null,
  postSnapshotResult: null,
  postingSnapshotByPeriodo: false,
  postingSnapshotByPeriodoError: null,
  putSnapshotEvaluacionResult: null,
  puttingSnapshotEvaluacion: false,
  puttingSnapshotEvaluacionError: null,
  deleteSnapshotEvaluacionResult: null,
  deletingSnapshotEvaluacion: false,
  deletingSnapshotEvaluacionError: null,
  resumenSnapshot: null,
  gettingResumenSnapshot: false,
  gettingResumenSnapshotError: null,
  cambiarVendedorResult: null,
  puttingCambiarVendedor: false,
  puttingCambiarVendedorError: null,
  cambiarPeriodoResult: null,
  puttingCambiarPeriodo: false,
  puttingCambiarPeriodoError: null,
  cambiarVendedorMasivoResult: null,
  postingCambiarVendedorMasivo: false,
  postingCambiarVendedorMasivoError: null,
  estadoProceso: null,
  gettingEstadoProceso: false,
  gettingEstadoProcesoError: null,
  calcularAlcancesCCResult: null,
  postingCalcularAlcancesCC: false,
  postingCalcularAlcancesCCError: null,
  precalculoCCResult: null,
  postingPrecalculoCC: false,
  postingPrecalculoCCError: null,
  calcularComisionesCCResult: null,
  postingCalcularComisionesCC: false,
  postingCalcularComisionesCCError: null,
  calcularAlcancesClubResult: null,
  postingCalcularAlcancesClub: false,
  postingCalcularAlcancesClubError: null,
  precalculoClubResult: null,
  postingPrecalculoClub: false,
  postingPrecalculoClubError: null,
  calcularComisionesClubResult: null,
  postingCalcularComisionesClub: false,
  postingCalcularComisionesClubError: null,
  calcularComisionesSemestralResult: null,
  postingCalcularComisionesSemestral: false,
  postingCalcularComisionesSemestralError: null,
  calculoSemestralAceptable: true,
  gettingCalculoSemestralAceptable: false,
  gettingCalculoSemestralAceptableError: null,
  revertirAlcancesCCResult: null,
  deletingRevertirAlcancesCC: false,
  deletingRevertirAlcancesCCError: null,
  revertirPrecalculoCCResult: null,
  deletingRevertirPrecalculoCC: false,
  deletingRevertirPrecalculoCCError: null,
  revertirComisionesCCResult: null,
  deletingRevertirComisionesCC: false,
  deletingRevertirComisionesCCError: null,
  revertirAlcancesClubResult: null,
  deletingRevertirAlcancesClub: false,
  deletingRevertirAlcancesClubError: null,
  revertirPrecalculoClubResult: null,
  deletingRevertirPrecalculoClub: false,
  deletingRevertirPrecalculoClubError: null,
  revertirComisionesClubResult: null,
  deletingRevertirComisionesClub: false,
  deletingRevertirComisionesClubError: null,
  revertirComisionesSemestralResult: null,
  deletingRevertirComisionesSemestral: false,
  deletingRevertirComisionesSemestralError: null,
  liderClubes: null,
  gettingLiderClubes: false,
  gettingLiderClubesError: null,
  liderReporte: null,
  gettingLiderReporte: false,
  gettingLiderReporteError: null,
  anualidadProyecto: null,
  gettingAnualidadProyecto: false,
  gettingAnualidadProyectoError: null,
  anualidadProyectosOptions: null,
  gettingAnualidadProyectosOptions: false,
  gettingAnualidadProyectosOptionsError: null
};

export default function comisionAnualidadReducer(
  state: State = initialState,
  action: IAction
): State {
  const snapshot = snapshotAction(state, action);

  state != snapshot &&
    !action.type.endsWith("_PENDING") &&
    action.meta &&
    action.meta.resolver &&
    action.meta.resolver({
      fulfilled: action.type.endsWith("_FULFILLED"),
      ...snapshot
    });

  return state != snapshot
    ? {
        ...state,
        ...snapshot
      }
    : state;
}

function snapshotAction(state: State = initialState, action: IAction) {
  switch (action.type) {
    case `${actionTypes.POST_COMISION_ANUALIDAD_CARGA_METAS}_PENDING`: {
      return {
        postingCargaAnualidadMeta: true,
        postingCargaAnualidadMetaError: null
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_CARGA_METAS}_REJECTED`: {
      return {
        cargaAnualidadMeta: null,
        postingCargaAnualidadMeta: false,
        postingCargaAnualidadMetaError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_CARGA_METAS}_FULFILLED`: {
      return {
        cargaAnualidadMeta: action.payload.data,
        postingCargaAnualidadMeta: false,
        postingCargaAnualidadMetaError: null
      };
    }

    case `${actionTypes.GET_COMISION_ANUALIDAD_METAS}_PENDING`: {
      return {
        gettingComisionAnualidadMetas: true,
        gettingComisionAnualidadMetasError: null
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_METAS}_REJECTED`: {
      return {
        comisionAnualidadMetas: null,
        gettingComisionAnualidadMetas: false,
        gettingComisionAnualidadMetasError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_METAS}_FULFILLED`: {
      return {
        comisionAnualidadMetas: action.payload.data,
        gettingComisionAnualidadMetas: false,
        gettingComisionAnualidadMetasError: null
      };
    }

    case `${actionTypes.CLEAR_COMISION_ANUALIDAD_SNAPSHOT}`: {
      return {
        snapshot: null,
        gettingSnapshot: false,
        gettingSnapshotError: null
      };
    }

    case `${actionTypes.GET_COMISION_ANUALIDAD_SNAPSHOT_BY_FOLIO}_PENDING`: {
      return {
        gettingSnapshot: true,
        gettingSnapshotError: null
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_SNAPSHOT_BY_FOLIO}_REJECTED`: {
      return {
        snapshot: null,
        gettingSnapshot: false,
        gettingSnapshotError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_SNAPSHOT_BY_FOLIO}_FULFILLED`: {
      return {
        snapshot: action.payload.data,
        gettingSnapshot: false,
        gettingSnapshotError: null
      };
    }

    case `${actionTypes.GET_COMISION_ANUALIDAD_SNAPSHOT_BY_PERIODO}_PENDING`: {
      return {
        gettingSnapshot: true,
        gettingSnapshotError: null
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_SNAPSHOT_BY_PERIODO}_REJECTED`: {
      return {
        snapshot: null,
        gettingSnapshot: false,
        gettingSnapshotError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_SNAPSHOT_BY_PERIODO}_FULFILLED`: {
      return {
        snapshot: action.payload.data,
        gettingSnapshot: false,
        gettingSnapshotError: null
      };
    }

    case `${actionTypes.GET_COMISION_ANUALIDAD_SNAPSHOT_BY_ASESOR}_PENDING`: {
      return {
        gettingSnapshot: true,
        gettingSnapshotError: null
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_SNAPSHOT_BY_ASESOR}_REJECTED`: {
      return {
        snapshot: null,
        gettingSnapshot: false,
        gettingSnapshotError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_SNAPSHOT_BY_ASESOR}_FULFILLED`: {
      return {
        snapshot: action.payload.data,
        gettingSnapshot: false,
        gettingSnapshotError: null
      };
    }

    // REPORTE GENERAL DE VENDEDORES (/reportes/reporte-general-vendedor)
    case `${actionTypes.GET_COMISION_ANUALIDAD_REPORTE_GENERAL_VENDEDOR}_PENDING`: {
      return {
        gettingSnapshot: true,
        gettingSnapshotError: null
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_REPORTE_GENERAL_VENDEDOR}_REJECTED`: {
      return {
        snapshot: null,
        gettingSnapshot: false,
        gettingSnapshotError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_REPORTE_GENERAL_VENDEDOR}_FULFILLED`: {
      // Axios → body; si viniera envuelto { data: Page }, desenvuelve
      const body = action.payload && action.payload.data;
      const page =
        body && body.content !== undefined
          ? body
          : body && body.data && body.data.content !== undefined
          ? body.data
          : body;
      return {
        snapshot: page,
        gettingSnapshot: false,
        gettingSnapshotError: null
      };
    }

    case `${actionTypes.POST_COMISION_ANUALIDAD_SNAPSHOT_BY_PERIODO}_PENDING`: {
      return {
        postingSnapshotByPeriodo: true,
        postingSnapshotByPeriodoError: null
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_SNAPSHOT_BY_PERIODO}_REJECTED`: {
      return {
        postSnapshotResult: null,
        postingSnapshotByPeriodo: false,
        postingSnapshotByPeriodoError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_SNAPSHOT_BY_PERIODO}_FULFILLED`: {
      return {
        postSnapshotResult: action.payload.data,
        postingSnapshotByPeriodo: false,
        postingSnapshotByPeriodoError: null
      };
    }

    case `${actionTypes.PUT_COMISION_ANUALIDAD_SNAPSHOT_EVALUACION}_PENDING`: {
      return {
        puttingSnapshotEvaluacion: true,
        puttingSnapshotEvaluacionError: null
      };
    }
    case `${actionTypes.PUT_COMISION_ANUALIDAD_SNAPSHOT_EVALUACION}_REJECTED`: {
      return {
        putSnapshotEvaluacionResult: null,
        puttingSnapshotEvaluacion: false,
        puttingSnapshotEvaluacionError: readMessageBack(action)
      };
    }
    case `${actionTypes.PUT_COMISION_ANUALIDAD_SNAPSHOT_EVALUACION}_FULFILLED`: {
      return {
        putSnapshotEvaluacionResult: action.payload.data,
        puttingSnapshotEvaluacion: false,
        puttingSnapshotEvaluacionError: null
      };
    }

    case `${actionTypes.DELETE_COMISION_ANUALIDAD_SNAPSHOT_EVALUACION}_PENDING`: {
      return {
        deletingSnapshotEvaluacion: true,
        deletingSnapshotEvaluacionError: null
      };
    }
    case `${actionTypes.DELETE_COMISION_ANUALIDAD_SNAPSHOT_EVALUACION}_REJECTED`: {
      return {
        deleteSnapshotEvaluacionResult: null,
        deletingSnapshotEvaluacion: false,
        deletingSnapshotEvaluacionError: readMessageBack(action)
      };
    }
    case `${actionTypes.DELETE_COMISION_ANUALIDAD_SNAPSHOT_EVALUACION}_FULFILLED`: {
      return {
        deleteSnapshotEvaluacionResult: action.payload.data,
        deletingSnapshotEvaluacion: false,
        deletingSnapshotEvaluacionError: null
      };
    }

    case `${actionTypes.CLEAR_COMISION_ANUALIDAD_RESUMEN}`: {
      return {
        resumenSnapshot: null,
        gettingResumenSnapshot: false,
        gettingResumenSnapshotError: null
      };
    }

    case `${actionTypes.GET_COMISION_ANUALIDAD_RESUMEN_BY_PERIODO}_PENDING`: {
      return {
        gettingResumenSnapshot: true,
        gettingResumenSnapshotError: null
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_RESUMEN_BY_PERIODO}_REJECTED`: {
      return {
        resumenSnapshot: null,
        gettingResumenSnapshot: false,
        gettingResumenSnapshotError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_RESUMEN_BY_PERIODO}_FULFILLED`: {
      return {
        resumenSnapshot: action.payload.data,
        gettingResumenSnapshot: false,
        gettingResumenSnapshotError: null
      };
    }

    case `${actionTypes.GET_COMISION_ANUALIDAD_RESUMEN_BY_PERIODO_CLUB}_PENDING`: {
      return {
        gettingResumenSnapshot: true,
        gettingResumenSnapshotError: null
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_RESUMEN_BY_PERIODO_CLUB}_REJECTED`: {
      return {
        resumenSnapshot: null,
        gettingResumenSnapshot: false,
        gettingResumenSnapshotError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_RESUMEN_BY_PERIODO_CLUB}_FULFILLED`: {
      return {
        resumenSnapshot: action.payload.data,
        gettingResumenSnapshot: false,
        gettingResumenSnapshotError: null
      };
    }

    case `${actionTypes.PUT_COMISION_ANUALIDAD_CAMBIAR_VENDEDOR}_PENDING`: {
      return {
        puttingCambiarVendedor: true,
        puttingCambiarVendedorError: null
      };
    }
    case `${actionTypes.PUT_COMISION_ANUALIDAD_CAMBIAR_VENDEDOR}_REJECTED`: {
      return {
        cambiarVendedorResult: null,
        puttingCambiarVendedor: false,
        puttingCambiarVendedorError: readMessageBack(action)
      };
    }
    case `${actionTypes.PUT_COMISION_ANUALIDAD_CAMBIAR_VENDEDOR}_FULFILLED`: {
      return {
        cambiarVendedorResult: action.payload.data,
        puttingCambiarVendedor: false,
        puttingCambiarVendedorError: null
      };
    }

    case `${actionTypes.PUT_COMISION_ANUALIDAD_CAMBIAR_PERIODO}_PENDING`: {
      return {
        puttingCambiarPeriodo: true,
        puttingCambiarPeriodoError: null
      };
    }
    case `${actionTypes.PUT_COMISION_ANUALIDAD_CAMBIAR_PERIODO}_REJECTED`: {
      return {
        cambiarPeriodoResult: null,
        puttingCambiarPeriodo: false,
        puttingCambiarPeriodoError: readMessageBack(action)
      };
    }
    case `${actionTypes.PUT_COMISION_ANUALIDAD_CAMBIAR_PERIODO}_FULFILLED`: {
      return {
        cambiarPeriodoResult: action.payload.data,
        puttingCambiarPeriodo: false,
        puttingCambiarPeriodoError: null
      };
    }

    case `${actionTypes.POST_COMISION_ANUALIDAD_CAMBIAR_VENDEDOR_MASIVO}_PENDING`: {
      return {
        postingCambiarVendedorMasivo: true,
        postingCambiarVendedorMasivoError: null
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_CAMBIAR_VENDEDOR_MASIVO}_REJECTED`: {
      return {
        cambiarVendedorMasivoResult: null,
        postingCambiarVendedorMasivo: false,
        postingCambiarVendedorMasivoError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_CAMBIAR_VENDEDOR_MASIVO}_FULFILLED`: {
      return {
        cambiarVendedorMasivoResult: action.payload.data,
        postingCambiarVendedorMasivo: false,
        postingCambiarVendedorMasivoError: null
      };
    }

    case `${actionTypes.GET_COMISION_ANUALIDAD_PROCESO_ESTADO}_PENDING`: {
      return {
        gettingEstadoProceso: true,
        gettingEstadoProcesoError: null
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_PROCESO_ESTADO}_REJECTED`: {
      return {
        estadoProceso: null,
        gettingEstadoProceso: false,
        gettingEstadoProcesoError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_PROCESO_ESTADO}_FULFILLED`: {
      return {
        estadoProceso: action.payload.data,
        gettingEstadoProceso: false,
        gettingEstadoProcesoError: null
      };
    }

    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_ALCANCES_CC}_PENDING`: {
      return {
        postingCalcularAlcancesCC: true,
        postingCalcularAlcancesCCError: null
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_ALCANCES_CC}_REJECTED`: {
      return {
        calcularAlcancesCCResult: null,
        postingCalcularAlcancesCC: false,
        postingCalcularAlcancesCCError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_ALCANCES_CC}_FULFILLED`: {
      return {
        calcularAlcancesCCResult: action.payload.data,
        postingCalcularAlcancesCC: false,
        postingCalcularAlcancesCCError: null
      };
    }

    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_PRECALCULO_CC}_PENDING`: {
      return {
        postingPrecalculoCC: true,
        postingPrecalculoCCError: null
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_PRECALCULO_CC}_REJECTED`: {
      return {
        precalculoCCResult: null,
        postingPrecalculoCC: false,
        postingPrecalculoCCError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_PRECALCULO_CC}_FULFILLED`: {
      return {
        precalculoCCResult: action.payload.data,
        postingPrecalculoCC: false,
        postingPrecalculoCCError: null
      };
    }

    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_COMISIONES_CC}_PENDING`: {
      return {
        postingCalcularComisionesCC: true,
        postingCalcularComisionesCCError: null
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_COMISIONES_CC}_REJECTED`: {
      return {
        calcularComisionesCCResult: null,
        postingCalcularComisionesCC: false,
        postingCalcularComisionesCCError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_COMISIONES_CC}_FULFILLED`: {
      return {
        calcularComisionesCCResult: action.payload.data,
        postingCalcularComisionesCC: false,
        postingCalcularComisionesCCError: null
      };
    }

    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_ALCANCES_CLUB}_PENDING`: {
      return {
        postingCalcularAlcancesClub: true,
        postingCalcularAlcancesClubError: null
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_ALCANCES_CLUB}_REJECTED`: {
      return {
        calcularAlcancesClubResult: null,
        postingCalcularAlcancesClub: false,
        postingCalcularAlcancesClubError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_ALCANCES_CLUB}_FULFILLED`: {
      return {
        calcularAlcancesClubResult: action.payload.data,
        postingCalcularAlcancesClub: false,
        postingCalcularAlcancesClubError: null
      };
    }

    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_PRECALCULO_CLUB}_PENDING`: {
      return {
        postingPrecalculoClub: true,
        postingPrecalculoClubError: null
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_PRECALCULO_CLUB}_REJECTED`: {
      return {
        precalculoClubResult: null,
        postingPrecalculoClub: false,
        postingPrecalculoClubError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_PRECALCULO_CLUB}_FULFILLED`: {
      return {
        precalculoClubResult: action.payload.data,
        postingPrecalculoClub: false,
        postingPrecalculoClubError: null
      };
    }

    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_COMISIONES_CLUB}_PENDING`: {
      return {
        postingCalcularComisionesClub: true,
        postingCalcularComisionesClubError: null
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_COMISIONES_CLUB}_REJECTED`: {
      return {
        calcularComisionesClubResult: null,
        postingCalcularComisionesClub: false,
        postingCalcularComisionesClubError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_COMISIONES_CLUB}_FULFILLED`: {
      return {
        calcularComisionesClubResult: action.payload.data,
        postingCalcularComisionesClub: false,
        postingCalcularComisionesClubError: null
      };
    }

    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_COMISIONES_SEMESTRAL}_PENDING`: {
      return {
        postingCalcularComisionesSemestral: true,
        postingCalcularComisionesSemestralError: null
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_COMISIONES_SEMESTRAL}_REJECTED`: {
      return {
        calcularComisionesSemestralResult: null,
        postingCalcularComisionesSemestral: false,
        postingCalcularComisionesSemestralError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_COMISIONES_SEMESTRAL}_FULFILLED`: {
      return {
        calcularComisionesSemestralResult: action.payload.data,
        postingCalcularComisionesSemestral: false,
        postingCalcularComisionesSemestralError: null
      };
    }

    case `${actionTypes.CLEAR_COMISION_ANUALIDAD_PROYECTO}`: {
      return {
        anualidadProyecto: null,
        gettingAnualidadProyecto: false,
        gettingAnualidadProyectoError: null
      };
    }

    case `${actionTypes.GET_COMISION_ANUALIDAD_LIDER_CLUBES}_PENDING`: {
      return {
        gettingLiderClubes: true,
        gettingLiderClubesError: null
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_LIDER_CLUBES}_REJECTED`: {
      return {
        liderClubes: null,
        gettingLiderClubes: false,
        gettingLiderClubesError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_LIDER_CLUBES}_FULFILLED`: {
      return {
        liderClubes: action.payload.data,
        gettingLiderClubes: false,
        gettingLiderClubesError: null
      };
    }

    case `${actionTypes.GET_COMISION_ANUALIDAD_LIDER_REPORTE}_PENDING`: {
      return {
        gettingLiderReporte: true,
        gettingLiderReporteError: null
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_LIDER_REPORTE}_REJECTED`: {
      return {
        liderReporte: null,
        gettingLiderReporte: false,
        gettingLiderReporteError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_LIDER_REPORTE}_FULFILLED`: {
      return {
        liderReporte: action.payload.data,
        gettingLiderReporte: false,
        gettingLiderReporteError: null
      };
    }

    case `${actionTypes.GET_COMISION_ANUALIDAD_PROYECTO_BY_PERIODO}_PENDING`: {
      return {
        gettingAnualidadProyecto: true,
        gettingAnualidadProyectoError: null
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_PROYECTO_BY_PERIODO}_REJECTED`: {
      return {
        anualidadProyecto: null,
        gettingAnualidadProyecto: false,
        gettingAnualidadProyectoError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_PROYECTO_BY_PERIODO}_FULFILLED`: {
      return {
        anualidadProyecto: action.payload.data,
        gettingAnualidadProyecto: false,
        gettingAnualidadProyectoError: null
      };
    }

    case `${actionTypes.GET_COMISION_ANUALIDAD_PROYECTOS_OPTIONS}_PENDING`: {
      return {
        gettingAnualidadProyectosOptions: true,
        gettingAnualidadProyectosOptionsError: null
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_PROYECTOS_OPTIONS}_REJECTED`: {
      return {
        anualidadProyectosOptions: null,
        gettingAnualidadProyectosOptions: false,
        gettingAnualidadProyectosOptionsError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_PROYECTOS_OPTIONS}_FULFILLED`: {
      return {
        anualidadProyectosOptions: action.payload.data,
        gettingAnualidadProyectosOptions: false,
        gettingAnualidadProyectosOptionsError: null
      };
    }

    case `${actionTypes.GET_COMISION_ANUALIDAD_PROCESO_CALCULO_SEMESTRAL_ACEPTABLE}_PENDING`: {
      return {
        gettingCalculoSemestralAceptable: true,
        gettingCalculoSemestralAceptableError: null
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_PROCESO_CALCULO_SEMESTRAL_ACEPTABLE}_REJECTED`: {
      return {
        calculoSemestralAceptable: false,
        gettingCalculoSemestralAceptable: false,
        gettingCalculoSemestralAceptableError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_PROCESO_CALCULO_SEMESTRAL_ACEPTABLE}_FULFILLED`: {
      return {
        calculoSemestralAceptable: true,
        gettingCalculoSemestralAceptable: false,
        gettingCalculoSemestralAceptableError: null
      };
    }

    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_ALCANCES_CC}_PENDING`: {
      return {
        deletingRevertirAlcancesCC: true,
        deletingRevertirAlcancesCCError: null
      };
    }
    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_ALCANCES_CC}_REJECTED`: {
      return {
        revertirAlcancesCCResult: null,
        deletingRevertirAlcancesCC: false,
        deletingRevertirAlcancesCCError: readMessageBack(action)
      };
    }
    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_ALCANCES_CC}_FULFILLED`: {
      return {
        revertirAlcancesCCResult: action.payload.data,
        deletingRevertirAlcancesCC: false,
        deletingRevertirAlcancesCCError: null
      };
    }

    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_PRECALCULO_CC}_PENDING`: {
      return {
        deletingRevertirPrecalculoCC: true,
        deletingRevertirPrecalculoCCError: null
      };
    }
    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_PRECALCULO_CC}_REJECTED`: {
      return {
        revertirPrecalculoCCResult: null,
        deletingRevertirPrecalculoCC: false,
        deletingRevertirPrecalculoCCError: readMessageBack(action)
      };
    }
    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_PRECALCULO_CC}_FULFILLED`: {
      return {
        revertirPrecalculoCCResult: action.payload.data,
        deletingRevertirPrecalculoCC: false,
        deletingRevertirPrecalculoCCError: null
      };
    }

    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_COMISIONES_CC}_PENDING`: {
      return {
        deletingRevertirComisionesCC: true,
        deletingRevertirComisionesCCError: null
      };
    }
    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_COMISIONES_CC}_REJECTED`: {
      return {
        revertirComisionesCCResult: null,
        deletingRevertirComisionesCC: false,
        deletingRevertirComisionesCCError: readMessageBack(action)
      };
    }
    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_COMISIONES_CC}_FULFILLED`: {
      return {
        revertirComisionesCCResult: action.payload.data,
        deletingRevertirComisionesCC: false,
        deletingRevertirComisionesCCError: null
      };
    }

    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_ALCANCES_CLUB}_PENDING`: {
      return {
        deletingRevertirAlcancesClub: true,
        deletingRevertirAlcancesClubError: null
      };
    }
    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_ALCANCES_CLUB}_REJECTED`: {
      return {
        revertirAlcancesClubResult: null,
        deletingRevertirAlcancesClub: false,
        deletingRevertirAlcancesClubError: readMessageBack(action)
      };
    }
    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_ALCANCES_CLUB}_FULFILLED`: {
      return {
        revertirAlcancesClubResult: action.payload.data,
        deletingRevertirAlcancesClub: false,
        deletingRevertirAlcancesClubError: null
      };
    }

    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_PRECALCULO_CLUB}_PENDING`: {
      return {
        deletingRevertirPrecalculoClub: true,
        deletingRevertirPrecalculoClubError: null
      };
    }
    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_PRECALCULO_CLUB}_REJECTED`: {
      return {
        revertirPrecalculoClubResult: null,
        deletingRevertirPrecalculoClub: false,
        deletingRevertirPrecalculoClubError: readMessageBack(action)
      };
    }
    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_PRECALCULO_CLUB}_FULFILLED`: {
      return {
        revertirPrecalculoClubResult: action.payload.data,
        deletingRevertirPrecalculoClub: false,
        deletingRevertirPrecalculoClubError: null
      };
    }

    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_COMISIONES_CLUB}_PENDING`: {
      return {
        deletingRevertirComisionesClub: true,
        deletingRevertirComisionesClubError: null
      };
    }
    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_COMISIONES_CLUB}_REJECTED`: {
      return {
        revertirComisionesClubResult: null,
        deletingRevertirComisionesClub: false,
        deletingRevertirComisionesClubError: readMessageBack(action)
      };
    }
    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_COMISIONES_CLUB}_FULFILLED`: {
      return {
        revertirComisionesClubResult: action.payload.data,
        deletingRevertirComisionesClub: false,
        deletingRevertirComisionesClubError: null
      };
    }

    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_COMISIONES_SEMESTRAL}_PENDING`: {
      return {
        deletingRevertirComisionesSemestral: true,
        deletingRevertirComisionesSemestralError: null
      };
    }
    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_COMISIONES_SEMESTRAL}_REJECTED`: {
      return {
        revertirComisionesSemestralResult: null,
        deletingRevertirComisionesSemestral: false,
        deletingRevertirComisionesSemestralError: readMessageBack(action)
      };
    }
    case `${actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_COMISIONES_SEMESTRAL}_FULFILLED`: {
      return {
        revertirComisionesSemestralResult: action.payload.data,
        deletingRevertirComisionesSemestral: false,
        deletingRevertirComisionesSemestralError: null
      };
    }

    case `${actionTypes.GET_COMISION_ANUALIDAD_ALCANCES}_PENDING`: {
      return {
        gettingComisionesAlcanceAnualidad: true,
        gettingComisionesAlcanceAnualidadError: null
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_ALCANCES}_REJECTED`: {
      return {
        comisionesAlcanceAnualidad: [],
        gettingComisionesAlcanceAnualidad: false,
        gettingComisionesAlcanceAnualidadError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_ANUALIDAD_ALCANCES}_FULFILLED`: {
      return {
        comisionesAlcanceAnualidad: action.payload.data,
        gettingComisionesAlcanceAnualidad: false,
        gettingComisionesAlcanceAnualidadError: null
      };
    }

    default:
      return state;
  }
}
